import React from 'react'
import Aos from 'aos'
import {
    CoCSList,
    WSSCList,
    MESList,
    YMSSList,
    MFSCList,
    ERMSList,
    SVSCList,
    MESCList,
    ATFList,
    LSComitteeList,
    SSCList,
    PDCList
} from './OtherSubCommitteList'

const OtherSubCommittee = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    });

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='container'>
                    {/* ऋण लगानी तथा असुली उपसमिति */}
                    <div className='heading1' data-aos='fade-right'>
                        <div className='h2'>
                            <h2>ऋण लगानी तथा असुली उपसमिति</h2><hr />
                        </div>
                    </div>
                    <div className='president2' data-aos='fade-right'>
                        {LSComitteeList.map((item, index) => {
                            return (
                                <div className='president2-body' key={index}>
                                    <div className='president2-img'>
                                        <img src={item.memImg} alt='AccountComittee' />
                                    </div>
                                    <div className='president2-detail'>
                                        <h2>{item.memName}</h2>
                                        <h3>{item.post}</h3>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    {/* सामाजिक सेवा उपसमिति */}
                    <div className='heading1' data-aos='fade-right'>
                        <div className='h2'>
                            <h2>सामाजिक सेवा उपसमिति</h2><hr />
                        </div>
                    </div>
                    <div className='president2' data-aos='fade-right'>
                        {SSCList.map((item, index) => {
                            return (
                                <div className='president2-body' key={index}>
                                    <div className='president2-img'>
                                        <img src={item.memImg} alt='AccountComittee' />
                                    </div>
                                    <div className='president2-detail'>
                                        <h2>{item.memName}</h2>
                                        <h3>{item.post}</h3>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    {/* कार्यविधि निर्माण उपसमिति */}
                    <div className='heading1' data-aos='fade-right'>
                        <div className='h2'>
                            <h2>कार्यविधि निर्माण उपसमिति</h2><hr />
                        </div>
                    </div>
                    <div className='president2' data-aos='fade-right'>
                        {PDCList.map((item, index) => {
                            return (
                                <div className='president2-body' key={index}>
                                    <div className='president2-img'>
                                        <img src={item.memImg} alt='AccountComittee' />
                                    </div>
                                    <div className='president2-detail'>
                                        <h2>{item.memName}</h2>
                                        <h3>{item.post}</h3>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    {/* सहयोग तथा समन्वयउपसमिति */}
                    <div className='heading1' data-aos='fade-right'>
                        <div className='h2'>
                            <h2>सहयोग तथा समन्वय उपसमिति</h2><hr />
                        </div>
                    </div>
                    <div className='president2' data-aos='fade-right'>
                        {CoCSList.map((item, index) => {
                            return (
                                <div className='president2-body' key={index}>
                                    <div className='president2-img'>
                                        <img src={item.memImg} alt='AccountComittee' />
                                    </div>
                                    <div className='president2-detail'>
                                        <h2>{item.memName}</h2>
                                        <h3>{item.post}</h3>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    {/* महिला सेवाउपसमिति */}
                    <div className='heading1' data-aos='fade-right'>
                        <div className='h2'>
                            <h2>महिला सेवा उपसमिति</h2><hr />
                        </div>
                    </div>
                    <div className='president2' data-aos='fade-right'>
                        {WSSCList.map((item, index) => {
                            return (
                                <div className='president2-body' key={index}>
                                    <div className='president2-img'>
                                        <img src={item.memImg} alt='AccountComittee' />
                                    </div>
                                    <div className='president2-detail'>
                                        <h2>{item.memName}</h2>
                                        <h3>{item.post}</h3>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    {/* अनुगमन तथा मूल्याङ्कन उपसमिति  */}
                    <div className='heading1' data-aos='fade-right'>
                        <div className='h2'>
                            <h2>अनुगमन तथा मूल्याङ्कन उपसमिति</h2><hr />
                        </div>
                    </div>
                    <div className='president2' data-aos='fade-right'>
                        {MESList.map((item, index) => {
                            return (
                                <div className='president2-body' key={index}>
                                    <div className='president2-img'>
                                        <img src={item.memImg} alt='AccountComittee' />
                                    </div>
                                    <div className='president2-detail'>
                                        <h2>{item.memName}</h2>
                                        <h3>{item.post}</h3>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    {/* युवा तथा सदस्य सेवा उपसमिति  */}
                    <div className='heading1' data-aos='fade-right'>
                        <div className='h2'>
                            <h2>युवा तथा सदस्य सेवा उपसमिति</h2><hr />
                        </div>
                    </div>
                    <div className='president2' data-aos='fade-right'>
                        {YMSSList.map((item, index) => {
                            return (
                                <div className='president2-body' key={index}>
                                    <div className='president2-img'>
                                        <img src={item.memImg} alt='AccountComittee' />
                                    </div>
                                    <div className='president2-detail'>
                                        <h2>{item.memName}</h2>
                                        <h3>{item.post}</h3>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    {/* लघुवित्त उपसमिति  */}
                    <div className='heading1' data-aos='fade-right'>
                        <div className='h2'>
                            <h2>लघुवित्त उपसमिति</h2><hr />
                        </div>
                    </div>
                    <div className='president2' data-aos='fade-right'>
                        {MFSCList.map((item, index) => {
                            return (
                                <div className='president2-body' key={index}>
                                    <div className='president2-img'>
                                        <img src={item.memImg} alt='AccountComittee' />
                                    </div>
                                    <div className='president2-detail'>
                                        <h2>{item.memName}</h2>
                                        <h3>{item.post}</h3>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    {/* उद्यमशिलता तथा श्रोतव्यवस्थापन उपसमिति  */}
                    <div className='heading1' data-aos='fade-right'>
                        <div className='h2'>
                            <h2>उद्यमशिलता तथा श्रोतव्यवस्थापन उपसमिति</h2><hr />
                        </div>
                    </div>
                    <div className='president2' data-aos='fade-right'>
                        {ERMSList.map((item, index) => {
                            return (
                                <div className='president2-body' key={index}>
                                    <div className='president2-img'>
                                        <img src={item.memImg} alt='AccountComittee' />
                                    </div>
                                    <div className='president2-detail'>
                                        <h2>{item.memName}</h2>
                                        <h3>{item.post}</h3>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    {/* धितोमूल्याङ्कन उपसमिति  */}
                    <div className='heading1' data-aos='fade-right'>
                        <div className='h2'>
                            <h2>धितोमूल्याङ्कन उपसमिति</h2><hr />
                        </div>
                    </div>
                    <div className='president2' data-aos='fade-right'>
                        {SVSCList.map((item, index) => {
                            return (
                                <div className='president2-body' key={index}>
                                    <div className='president2-img'>
                                        <img src={item.memImg} alt='AccountComittee' />
                                    </div>
                                    <div className='president2-detail'>
                                        <h2>{item.memName}</h2>
                                        <h3>{item.post}</h3>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    {/* सदस्य विस्तार उपसमिति  */}
                    <div className='heading1' data-aos='fade-right'>
                        <div className='h2'>
                            <h2>सदस्य विस्तार उपसमिति</h2><hr />
                        </div>
                    </div>
                    <div className='president2' data-aos='fade-right'>
                        {MESCList.map((item, index) => {
                            return (
                                <div className='president2-body' key={index}>
                                    <div className='president2-img'>
                                        <img src={item.memImg} alt='AccountComittee' />
                                    </div>
                                    <div className='president2-detail'>
                                        <h2>{item.memName}</h2>
                                        <h3>{item.post}</h3>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    {/* एक्सेस कार्यदल  */}
                    <div className='heading1' data-aos='fade-right'>
                        <div className='h2'>
                            <h2>एक्सेस कार्यदल</h2><hr />
                        </div>
                    </div>
                    <div className='president2' data-aos='fade-right'>
                        {ATFList.map((item, index) => {
                            return (
                                <div className='president2-body' key={index}>
                                    <div className='president2-img'>
                                        <img src={item.memImg} alt='AccountComittee' />
                                    </div>
                                    <div className='president2-detail'>
                                        <h2>{item.memName}</h2>
                                        <h3>{item.post}</h3>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default OtherSubCommittee